import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ThemeTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private themeName: string) {}

  public getTranslation(lang: string): Observable<any> {
    const base$ = this.http.get(`/assets/i18n/base/${lang}.json`);
    const theme$ = this.http.get(`/themes/${this.themeName}/translations/${lang}.json`);

    return forkJoin([base$, theme$]).pipe(
      map(([base, theme]) => deepMerge(base, theme))
    );
  }
}

function deepMerge(target: any, source: any) {
  const output = { ...target };
  Object.keys(source || {}).forEach(key => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      output[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      output[key] = source[key];
    }
  });
  return output;
}
